<template>
  <div class="payment-ae-component q-mt-lg q-pt-md">
    <h3 class="text-center">{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_AE_SECTION_TITLE") }}</h3>

    <QList class="text-left">
      <QItem>
        <QItemSection>
          <QItemLabel>
            <strong>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_DURATION") }}</strong>
          </QItemLabel>
          <QItemLabel caption>
            {{ $tc("ETAB.PAGES.DEMANDS.CREATION.@PRICING_NUMBER_OF_EXTRA", pricingBoost.getTotalExtra()) }}
          </QItemLabel>
        </QItemSection>

        <QItemSection side>
          <QItemLabel>
            <strong>{{ pricingBoost.getDurationDisplay() }}</strong>
          </QItemLabel>
        </QItemSection>
      </QItem>

      <QItem>
        <QItemSection>
          <QItemLabel>
            <b>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_HT_PRICE_HOUR") }}</b>
          </QItemLabel>
          <QItemLabel caption>
            {{ pricingBoost.getQualification() }}
          </QItemLabel>
        </QItemSection>

        <QItemSection side>
          <QItemLabel>
            <small v-if="hasBoost" class="q-mr-sm">
              <s>{{ pricingBoost.getHourlyRateDisplay() }}</s>
            </small>
            <strong>{{ boostedHourlyRate }}</strong>
          </QItemLabel>
        </QItemSection>
      </QItem>

      <QSeparator spaced inset />

      <QItem class="text-secondary">
        <QItemSection avatar>
          <QIcon color="secondary" name="icon-f-file-text" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>
            <strong>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_TOTAL_HT") }}</strong>
          </QItemLabel>
        </QItemSection>

        <QItemSection side>
          <QItemLabel class="text-secondary">
            <small v-if="hasBoost" class="q-mr-sm">
              <s>{{ pricingBoost.getPriceDisplay() }}</s>
            </small>
            <strong>{{ boostedPrice }}</strong>
          </QItemLabel>
        </QItemSection>
      </QItem>
    </QList>
  </div>
</template>

<script>
import { NumericHelpers } from "@core/helpers";
import { CreationStepPricingBoostModel } from "@core/models";

export default {
  props: {
    pricingBoost: {
      type: Object,
      default: () => new CreationStepPricingBoostModel(),
    },
    boostPercentage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hasBoost() {
      return this.boostPercentage && this.boostPercentage > 0;
    },
    basePrice() {
      return this.pricingBoost.getDuration() * this.pricingBoost.getHourlyRate();
    },
    boostedHourlyRate() {
      const number = NumericHelpers.applyPercentage({ amount: this.pricingBoost.getHourlyRate(), percentage: this.boostPercentage });
      return NumericHelpers.formatNumberAsCurrency({ number, forceTrailingZeros: true });
    },
    boostedPrice() {
      const number = NumericHelpers.applyPercentage({ amount: this.basePrice, percentage: this.boostPercentage });
      return NumericHelpers.formatNumberAsCurrency({ number, forceTrailingZeros: true });
    },
  },
};
</script>

<style lang="scss">
.payment-ae-component {
  border-radius: 4px;
  box-shadow: $card-shadow;
  background: white;
}
</style>
